













import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
export default defineComponent({
  name: "ImageUpload",
  components: { BaseInputFile, BaseIcon },
  props: {
    fitContent: { type: Boolean },
  },
});
